var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPark2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 12.5,
    fill: "#fcc24c",
    r: 6.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 26,
    fill: "#80d25b",
    r: 13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2663531 60.6728147v-26l-7.2663531-8.6728147",
    stroke: "#ab5f5f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 34.6923455 4.4743292-5.6923455",
    stroke: "#ab5f5f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6830941 48.9507178c.1750223-.5250669.7642711-.9507178 1.3150596-.9507178h28.0036926c.5512651 0 1.1419888.4315052 1.3150596.9507178l1.3661882 4.0985644c.1750223.5250669-.1380184.9507178-.6822362.9507178h-32.0017158c-.5518109 0-.855307-.4315052-.6822362-.9507178z",
    fill: "#ab5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1 61h63v3h-63z",
    fill: "#80d25b"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30 55v5",
    stroke: "#bd7575",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33 41v6",
    stroke: "#bd7575",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58 55v5",
    stroke: "#bd7575",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 41v6",
    stroke: "#bd7575",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 42h28.0172363",
    stroke: "#ab5f5f",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 45h28.0172363",
    stroke: "#ab5f5f",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.0446833 19.9340478-2.9031025 2.9031025",
    stroke: "#fcc24c",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.85186 13h-3.85186",
    stroke: "#fcc24c",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 23v4",
    stroke: "#fcc24c",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPark2);
export default __webpack_public_path__ + "static/media/park-2.18e7ac5bee508b11ad1f5b5369750e52.svg";
export { ForwardRef as ReactComponent };